import { render, staticRenderFns } from "./BusCommonMessageBlackIpList.vue?vue&type=template&id=1ffd401e&scoped=true&"
import script from "./BusCommonMessageBlackIpList.vue?vue&type=script&lang=js&"
export * from "./BusCommonMessageBlackIpList.vue?vue&type=script&lang=js&"
import style0 from "./BusCommonMessageBlackIpList.vue?vue&type=style&index=0&id=1ffd401e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ffd401e",
  null
  
)

export default component.exports